import hanedaAirportImage from "../../assets/pickup-area-cards/haneda_airport.png";
import naritaAirportImage from "../../assets/pickup-area-cards/narita_airport.png";
import tokyoImage from "../../assets/pickup-area-cards/tokyo.png";
import yokohamaPortImage from "../../assets/pickup-area-cards/yokohama_port.png";
import kamakuraImage from "../../assets/pickup-area-cards/kamakura.png";
import hakoneImage from "../../assets/pickup-area-cards/hakone.png";
import mtFujiImage from "../../assets/pickup-area-cards/mt_fuji.png";
import odawaraImage from "../../assets/pickup-area-cards/odawara.png";
import mishimaImage from "../../assets/pickup-area-cards/mishima.png";
import nikkoImage from "../../assets/pickup-area-cards/nikko.png";
import kawagoeImage from "../../assets/pickup-area-cards/kawagoe.png";
import karuizawaImage from "../../assets/pickup-area-cards/karuizawa.png";
import shizuokaImage from "../../assets/pickup-area-cards/shizuoka.png";
import osakaImage from "../../assets/pickup-area-cards/osaka.png";
import kyotoImage from "../../assets/pickup-area-cards/kyoto.png";
import naraImage from "../../assets/pickup-area-cards/nara.png";
import kobeImage from "../../assets/pickup-area-cards/kobe.png";
import kansaiAirportImage from "../../assets/pickup-area-cards/kansai_airport.png";
import itamiAirportImage from "../../assets/pickup-area-cards/itami_airport.png";
import kanazawaImage from "../../assets/pickup-area-cards/kanazawa.png";
import okinawaImage from "../../assets/pickup-area-cards/okinawa.png";
import otherImage from "../../assets/pickup-area-cards/other.png";

const PICKUP_AREA_IMAGES = {
  haneda_airport: hanedaAirportImage,
  narita_airport: naritaAirportImage,
  tokyo: tokyoImage,
  yokohama_port: yokohamaPortImage,
  kamakura: kamakuraImage,
  hakone: hakoneImage,
  mt_fuji: mtFujiImage,
  odawara: odawaraImage,
  mishima: mishimaImage,
  nikko: nikkoImage,
  kawagoe: kawagoeImage,
  karuizawa: karuizawaImage,
  shizuoka: shizuokaImage,
  osaka: osakaImage,
  kyoto: kyotoImage,
  nara: naraImage,
  kobe: kobeImage,
  kansai_airport: kansaiAirportImage,
  itami_airport: itamiAirportImage,
  kanazawa: kanazawaImage,
  okinawa: okinawaImage,
  other: otherImage,
};

const PICKUP_AREA_GROUPS = [
  {
    labelKey: "kantoRegion",
    fallbackLabel: "关东地区",
    codes: [
      "haneda_airport",
      "narita_airport",
      "tokyo",
      "yokohama_port",
      "kamakura",
      "hakone",
      "mt_fuji",
      "odawara",
      "mishima",
      "nikko",
      "kawagoe",
      "karuizawa",
      "shizuoka",
    ],
  },
  {
    labelKey: "kansaiRegion",
    fallbackLabel: "关西地区",
    codes: ["osaka", "kyoto", "nara", "kobe", "kansai_airport", "itami_airport"],
  },
  {
    labelKey: "otherRegion",
    fallbackLabel: "其他地区",
    codes: ["kanazawa", "okinawa", "other"],
  },
];

function PickupAreaImageButton({ code, area, formData, getAreaName, setFormData, t }) {
  const selected = formData.pickup_area === code;
  const label = code === "other" ? t.other : getAreaName(area);

  return (
    <button
      type="button"
      data-testid={`pickup-area-${code}`}
      aria-pressed={selected}
      aria-label={label}
      onClick={() => setFormData({ ...formData, pickup_area: code })}
      className={`group relative block overflow-hidden rounded-[14px] bg-[#050403]/80 p-1.5 text-center transition duration-200 pickup-area-image-card ${
        selected
          ? "shadow-[0_0_0_2px_rgba(245,212,128,0.95),0_12px_26px_rgba(0,0,0,0.34)]"
          : "shadow-[0_0_0_1px_rgba(205,156,68,0.42)] hover:shadow-[0_0_0_1px_rgba(245,212,128,0.8),0_10px_22px_rgba(0,0,0,0.28)]"
      }`}
    >
      <div className="relative aspect-[1.42/1] overflow-hidden rounded-[10px] bg-black">
        <img
          src={PICKUP_AREA_IMAGES[code]}
          alt=""
          draggable="false"
          className={`h-full w-full object-contain transition duration-300 ${
            selected ? "scale-[1.015] brightness-110" : "group-hover:scale-[1.018] group-hover:brightness-110"
          }`}
        />
      </div>
      <span className="flex min-h-[34px] items-center justify-center px-1 pt-1.5 text-sm font-semibold leading-snug text-[#f3d98b] sm:text-[15px]">
        {label}
      </span>
      <span
        className={`pointer-events-none absolute inset-0 rounded-[14px] transition ${
          selected
            ? "bg-[#f5d480]/8 ring-2 ring-[#f5d480]"
            : "bg-transparent ring-1 ring-inset ring-[#d8b769]/25"
        }`}
      />
      {selected && (
        <span className="pointer-events-none absolute right-2.5 top-2.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#f5d480] text-[10px] font-black text-[#141006] shadow-lg">
          ✓
        </span>
      )}
    </button>
  );
}

export default function PickupAreaStep({ areas, formData, getAreaName, setFormData, t }) {
  return (
    <div className="pickup-area-image-grid">
      <h2 className="sr-only">{t.step1Title}</h2>

      <div className="space-y-7">
        {PICKUP_AREA_GROUPS.map((group) => {
          const groupLabel = t[group.labelKey] || group.fallbackLabel;

          return (
            <section key={group.labelKey} aria-label={groupLabel}>
              <div className="mb-2.5 flex items-center gap-3">
                <span className="h-px w-6 bg-[#d8b769]" />
                <h3 className="text-sm font-semibold tracking-[0.16em] text-[#f3d98b] sm:text-base">
                  {groupLabel}
                </h3>
              </div>
              <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
                {group.codes.map((code) => {
                  const area = code === "other" ? null : areas.find((item) => item.code === code);
                  if (code !== "other" && !area) return null;

                  return (
                    <PickupAreaImageButton
                      key={code}
                      code={code}
                      area={area}
                      formData={formData}
                      getAreaName={getAreaName}
                      setFormData={setFormData}
                      t={t}
                    />
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>

      {formData.pickup_area === "other" && (
        <div className="mt-5">
          <input
            type="text"
            value={formData.pickup_area_other}
            onChange={(e) => setFormData({ ...formData, pickup_area_other: e.target.value })}
            placeholder={t.otherInput}
            className="premium-input"
          />
        </div>
      )}
    </div>
  );
}
